
import * as _asset0 from "inline-asset:assets/galleries/ua-2021-11-17/L1000497-bw_f25a5b2e08__20.jpg";
import * as _asset1 from "asset:assets/galleries/ua-2021-11-17/L1000497-bw_f25a5b2e08__400.jpg";
import * as _asset2 from "asset:assets/galleries/ua-2021-11-17/L1000497-bw_f25a5b2e08__800.jpg";
import * as _asset3 from "asset:assets/galleries/ua-2021-11-17/L1000497-bw_f25a5b2e08__1600.jpg";


export default {
  id: "L1000497-bw",
  aspect: 1.5123392422662496,
  alt: undefined,
  sources: [{
              url: _asset0.url,
              width: 20,
            },{
              url: _asset1.url,
              width: 400,
            },{
              url: _asset2.url,
              width: 800,
            },{
              url: _asset3.url,
              width: 1600,
            }],
};
        